<div class="gallery-container" *ngIf="images.length > 0 && displayCustom === false">
    <div class="image-wrapper" tabindex="0" (click)="imageClick()"
        [attr.aria-label]=" 'iaa.aria.moveToGallery' | translate" [ngClass]="{'loading' : loadingImage}">
        <img [ngSrc]="thumbnails[this.activeIndex]?.imageUrl || images[this.activeIndex].imageUrl"
            [alt]="images[this.activeIndex].imageDescription || 'iaa.scientificArchiveDocument.scientificArchiveDocumentDetails.archiveImageGallery.documentImage'| translate" fill (load)="imageLoad()" />
<i class="pi pi-search-plus magnifying-glass" [ngClass]="{'en': (currentLanguage | async) === 'en'}"></i>
    </div>
    <div *ngIf="images[this.activeIndex].imageCaption" class="image-info">
        {{ images[this.activeIndex].imageCaption }}
    </div>
    <div class="image-pagination">
        <div class="btn-left">
            <p-button styleClass="nav-btn" [tabindex]="0" [disabled]="activeIndex == images.length -1" [rounded]="true"
                [text]="true" [ariaLabel]="'iaa.aria.imageLast' | translate" icon="pi pi-angle-double-right"
                (click)="lastImage()" (keydown.enter)="lastImage()" />
            <p-button styleClass="nav-btn" [tabindex]="0" [disabled]="activeIndex == images.length -1" [rounded]="true"
                [text]="true" [ariaLabel]="'iaa.aria.imageNext' | translate" icon="pi pi-angle-right"
                (click)="nextImage()" (keydown.enter)="nextImage()" />
        </div>
        <div class="info" aria-live="polite">
            {{ activeIndex + 1 }} / {{ images.length }}
        </div>
        <div class="btn-right">
            <p-button styleClass="nav-btn" [tabindex]="0" [disabled]="activeIndex == 0" [rounded]="true" [text]="true"
                [ariaLabel]="'iaa.aria.imagePrev' | translate" icon="pi pi-angle-left" (click)="prevImage()"
                (keydown.enter)="prevImage()" />
            <p-button styleClass="nav-btn" [tabindex]="0" [disabled]="activeIndex == 0" [rounded]="true" [text]="true"
                [ariaLabel]="'iaa.aria.imageFirst' | translate" icon="pi pi-angle-double-left" (click)="firstImage()"
                (keydown.enter)="firstImage()" />
        </div>
    </div>
</div>
<p-galleria containerClass="archive-gallery" [value]="images" [(visible)]="displayCustom" [(activeIndex)]="activeIndex"
    [containerStyle]="{ 'width': '80%' }" [fullScreen]="true" [showItemNavigators]="true" [showIndicators]="false"
    [showThumbnails]="false" (visibleChange)="resetZoom()" (activeIndexChange)="scrollerTop()">
    <ng-template pTemplate="header">
        <p-toolbar class="toolbar" [attr.aria-label]=" 'iaa.aria.zoomActions' | translate ">
            <p-button icon="pi pi-search-minus icon" [tabindex]="0" [link]="true" [rounded]="true" [text]="true"
                (click)="zoomOut()" (keydown.enter)="zoomOut()" [ariaLabel]="'iaa.aria.zoomOut' | translate"></p-button>
            <p-button [tabindex]="0" [link]="true" [text]="true" label="Fit to width" (click)="imageChange()"
                (keydown.enter)="imageChange()" [ariaLabel]="'iaa.aria.fitToWidth' | translate"></p-button>
            <p-button [tabindex]="0" icon="pi pi-search-plus icon" [link]="true" [rounded]="true" [text]="true"
                (click)="zoomIn()" (keydown.enter)="zoomIn()" [ariaLabel]="'iaa.aria.zoomIn' | translate"></p-button>
        </p-toolbar>
    </ng-template>
    <ng-template pTemplate="item" let-item>
        <div #scroller style="height: 80dvh; overflow: auto; width: 100%;">
            <img #previewImage [src]="item.imageUrl" class="gallery-image" [ngClass]="{'loading': loadingPreviewImage}"
                [alt]="item.imageDescription" (load)="imageChange()" [title]="item.imageDescription" />
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="paging-caption" *ngIf="showActivePage" aria-live="polite">
            {{ activeIndex + 1 }} / {{ images.length }}
        </div>
    </ng-template>
</p-galleria>